module.exports = __webpack_public_path__ + "img/four.a8b082dd.svg";